var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRepeatOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1032 14.4838C30.1032 14.4838 30.1025 14.4864 30.0999 14.4915C30.1017 14.4863 30.1032 14.4838 30.1032 14.4838ZM1.8968 14.4838C1.8968 14.4838 1.89829 14.4863 1.90014 14.4915C1.89753 14.4864 1.8968 14.4838 1.8968 14.4838ZM1.8968 14.7378C1.8968 14.7378 1.89753 14.7352 1.90014 14.7301C1.89829 14.7353 1.8968 14.7378 1.8968 14.7378ZM30.0999 14.7301C30.1008 14.732 30.1015 14.7335 30.1021 14.7347C30.1029 14.7368 30.1032 14.7378 30.1032 14.7378C30.1032 14.7378 30.1017 14.7353 30.0999 14.7301Z",
    fill: "url(#hinava_random_uuid_275608892916639035040277245815424629828)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1032 14.4838C30.1032 14.4838 30.1025 14.4864 30.0999 14.4915C30.1017 14.4863 30.1032 14.4838 30.1032 14.4838ZM1.8968 14.4838C1.8968 14.4838 1.89829 14.4863 1.90014 14.4915C1.89753 14.4864 1.8968 14.4838 1.8968 14.4838ZM1.8968 14.7378C1.8968 14.7378 1.89753 14.7352 1.90014 14.7301C1.89829 14.7353 1.8968 14.7378 1.8968 14.7378ZM30.0999 14.7301C30.1008 14.732 30.1015 14.7335 30.1021 14.7347C30.1029 14.7368 30.1032 14.7378 30.1032 14.7378C30.1032 14.7378 30.1017 14.7353 30.0999 14.7301Z",
    fill: "url(#hinava_random_uuid_159736042621549997143611802635680878733)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7838 14.8071C16.6419 14.7101 16.4738 14.6579 16.3015 14.6579C15.8291 14.6579 15.4464 15.041 15.4464 15.513V17.53V19.4463V21.4675C15.4464 21.6394 15.4981 21.8074 15.5952 21.9498C15.8615 22.3398 16.3939 22.4398 16.7838 22.1734L21.143 19.1966C21.2306 19.1368 21.3067 19.0607 21.3666 18.973C21.633 18.5831 21.5329 18.0507 21.143 17.7843L16.7838 14.8071Z",
    fill: "url(#hinava_random_uuid_13824983794889355634826951099873448862)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0099 14.6108C29.9407 14.5348 29.8233 14.4258 29.6282 14.2863C29.0569 13.8778 28.1063 13.4311 26.7591 13.0237C24.0888 12.2162 20.2844 11.6886 16 11.6886C11.7156 11.6886 7.91123 12.2162 5.24093 13.0237C3.89372 13.4311 2.94308 13.8778 2.37179 14.2863C2.17666 14.4258 2.0593 14.5348 1.99006 14.6108C2.0593 14.6867 2.17666 14.7958 2.37179 14.9353C2.94308 15.3438 3.89372 15.7905 5.24093 16.1979C7.79564 16.9704 11.3884 17.4867 15.4464 17.53V19.4463C6.86617 19.358 0 17.2269 0 14.6108C0 11.9387 7.16344 9.77246 16 9.77246C24.8366 9.77246 32 11.9387 32 14.6108C32 16.4549 28.588 18.0581 23.5689 18.8746V16.9318C24.7523 16.7285 25.8251 16.4803 26.7591 16.1979C28.1063 15.7905 29.0569 15.3438 29.6282 14.9353C29.8233 14.7958 29.9407 14.6867 30.0099 14.6108ZM30.1032 14.4838C30.1032 14.4838 30.1025 14.4864 30.0999 14.4915C30.1017 14.4863 30.1032 14.4838 30.1032 14.4838ZM1.8968 14.4838C1.8968 14.4838 1.89829 14.4863 1.90014 14.4915C1.89753 14.4864 1.8968 14.4838 1.8968 14.4838ZM1.8968 14.7378C1.8968 14.7378 1.89753 14.7352 1.90014 14.7301C1.89829 14.7353 1.8968 14.7378 1.8968 14.7378ZM30.1021 14.7347C30.1015 14.7335 30.1008 14.732 30.0999 14.7301C30.1017 14.7353 30.1032 14.7378 30.1032 14.7378C30.1032 14.7378 30.1029 14.7368 30.1021 14.7347Z",
    fill: "url(#hinava_random_uuid_325390958009388214869868182452071442433)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_275608892916639035040277245815424629828",
    x1: 16,
    y1: 9.77246,
    x2: 16,
    y2: 22.3226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_159736042621549997143611802635680878733",
    x1: 16,
    y1: 9.77246,
    x2: 16,
    y2: 22.3226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_13824983794889355634826951099873448862",
    x1: 27.0899,
    y1: 9.77178,
    x2: 27.0899,
    y2: 22.3226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_325390958009388214869868182452071442433",
    x1: 16,
    y1: 9.77246,
    x2: 16,
    y2: 22.3226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeatOn);
export default __webpack_public_path__ + "static/media/repeat-on.972f95ac775b7017dcd55f660868db04.svg";
export { ForwardRef as ReactComponent };